import { render, staticRenderFns } from "./FeaturedPositions.vue?vue&type=template&id=2468afb9&scoped=true&"
import script from "./FeaturedPositions.vue?vue&type=script&lang=js&"
export * from "./FeaturedPositions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2468afb9",
  null
  
)

export default component.exports